var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31641 3.39967L5.12474 2.20801C3.12474 3.73301 1.80807 6.08301 1.69141 8.74967H3.35807C3.48307 6.54134 4.61641 4.60801 6.31641 3.39967ZM16.6414 8.74967H18.3081C18.1831 6.08301 16.8664 3.73301 14.8747 2.20801L13.6914 3.39967C15.3747 4.60801 16.5164 6.54134 16.6414 8.74967ZM14.9997 9.16634C14.9997 6.60801 13.6331 4.46634 11.2497 3.89967V3.33301C11.2497 2.64134 10.6914 2.08301 9.99974 2.08301C9.30807 2.08301 8.74974 2.64134 8.74974 3.33301V3.89967C6.35807 4.46634 4.99974 6.59967 4.99974 9.16634V13.333L3.33307 14.9997V15.833H16.6664V14.9997L14.9997 13.333V9.16634ZM9.99974 18.333C10.1164 18.333 10.2247 18.3247 10.3331 18.2997C10.8747 18.183 11.3164 17.8163 11.5331 17.3163C11.6164 17.1163 11.6581 16.8997 11.6581 16.6663H8.32474C8.33307 17.583 9.07474 18.333 9.99974 18.333Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsActive);
export default __webpack_public_path__ + "static/media/notifications-active.1e11dfb45b4ae4498c41110dadcf341d.svg";
export { ForwardRef as ReactComponent };